module.exports = __webpack_public_path__ + "img/sol_isol_pain1.9b47d4c9.png";